import { createLazyFileRoute } from "@tanstack/react-router";
import { memo } from "react";

import { WorklistPage } from "@/features/runs/routes/WorklistPage";

export const Route = createLazyFileRoute(
  "/_auth/_app/runs/$id/worklist/$testId",
)({
  component: memo(WorklistPage),
});
